import React from "react";
import { AiFill, Chevron } from "../../assets/svgs/icons";

export interface CardSocratesProps {
  title: string;
  metadata: string[];
  createdDate: string;
  onStartInterview?: () => void;
  className?: string;
}

const CardSocrates: React.FC<CardSocratesProps> = ({
  title,
  metadata,
  createdDate,
  onStartInterview,
  className = "",
}) => {
  return (
    <div
      className={`
        border border-[#e2d5fc] rounded-[20px] p-4
        flex flex-col gap-4 w-full min-w-[312px] max-w-[312px]
        bg-white hover:shadow-[0_4px_8px_rgba(226,213,252,0.4)]
        transition-all duration-200
        ${className}
      `}
    >
      {/* Title and action button */}
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-1">
          <AiFill className="w-5 h-5 [&_path]:fill-[#212121]" />
          <h3 className="font-bold text-[16px] leading-[20px] tracking-[-0.32px] text-[#212121]">
            {title}
          </h3>
        </div>

        <button
          type="button"
          onClick={onStartInterview}
          className="flex items-center justify-center h-8 rounded-[4px] hover:bg-[#f7f7f7] transition-colors"
        >
          <span className="font-medium text-[14px] leading-[20px] tracking-[-0.28px] text-[#6d2ef2] underline underline-offset-2">
            면접시작
          </span>
          <Chevron className="w-5 h-5 [&_path]:fill-[#6d2ef2]" />
        </button>
      </div>

      {/* Metadata tags */}
      <div className="flex flex-wrap items-center gap-1 w-full">
        {metadata.map((item, index) => (
          <React.Fragment key={index}>
            <span className="font-medium text-[14px] leading-[20px] tracking-[-0.28px] text-[#212121]">
              {item}
            </span>
            {index < metadata.length - 1 && (
              <div className="w-px h-3 bg-[#e0e0e0]" />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Created date */}
      <div className="w-full text-right">
        <p className="font-normal text-[12px] leading-[16px] tracking-[-0.24px] text-[#888888]">
          생성일 {createdDate}
        </p>
      </div>
    </div>
  );
};

export default CardSocrates;
